module.exports = __webpack_public_path__ + "034c228844716a7842202314f2b26cb4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-90.png
// module id = 152
// module chunks = 0